export default {
  "app.dashboard.analysis.timeLabel": "Time",
  "component.globalHeader.notification": "Notification",
  "component.globalHeader.notification.empty":
    "You have viewed all notifications",
  "component.globalHeader.message": "Message",
  "component.globalHeader.message.empty": "You have read all messages",
  "component.globalHeader.event": "To-Do",
  "component.globalHeader.event.empty": "You have completed all to-dos",
  "component.globalHeader.warn": "Warning",
  "component.globalHeader.warn.empty": "You have read all device warnings",
  "component.noticeIcon.clear": "Clear",
  "component.noticeIcon.cleared": "Cleared",
  "component.noticeIcon.empty": "No data available",
  "component.noticeIcon.view-more": "View More",
  "app.device.summary.listLabel": "Product List",
  "DeviceList.deviceid": "Device ID",
  "DeviceList.battery": "Battery",
  "DeviceList.signal": "Signal",
  "DeviceList.step": "Steps",
  "DeviceList.distance": "Distance (m)",
  "DeviceList.calorie": "Calories (kcal)",
  "DeviceList.model": "Device Model",
  "DeviceList.clientid": "Client ID",
  "DeviceList.viewdata": "View",
  "DeviceList.group.mesage": "Group Message",
  "DeviceList.action": "Action",
  "User.logout": "Logout",
  "DeviceSummary.baseinfo": "Basic Information",
  "DeviceSummary.watchname": "4G Health Watch",
  "DeviceSummary.blewatchname": "Bluetooth Health Watch",
  "DeviceSummary.deviceinfo": "Device Information",
  "DeviceSummary.datasync": "Sync Data",
  "DeviceSummary.summary": "Overview",
  "DeviceSummary.hr": "Heart Rate",
  "DeviceSummary.rri": "Atrial Fibrillation",
  "DeviceSummary.ecg": "ECG",
  "DeviceSummary.sport": "Sports",
  "DeviceSummary.sleep": "Sleep",
  "DeviceSummary.gnss": "Location",
  "DeviceSummary.male": "Male",
  "DeviceSummary.female": "Female",
  "DeviceSummary.gender": "Gender",
  "DeviceSummary.height": "Height",
  "DeviceSummary.no": "No",
  "DeviceSummary.weight": "Weight",
  "DeviceSummary.birthday": "Date of Birth",
  "DeviceSummary.imei": "Device IMEI",
  "DeviceSummary.online": "Online",
  "DeviceSummary.offline": "Offline",
  "DeviceSummary.edit": "Edit",
  "DeviceSummary.nickname": "Nickname",
  "DeviceSummary.target.step": "Target Steps",
  "DeviceSummary.target.calorie": "Target Calories",
  "DeviceSummary.save": "Save",
  "DeviceSummary.cancel": "Cancel",
  "DeviceSummary.nickname.input": "Please enter nickname",
  "DeviceSummary.gender.input": "Please select gender",
  "DeviceSummary.height.input": "Please enter height",
  "DeviceSummary.weight.input": "Please enter weight",
  "DeviceSummary.birthday.input": "Please enter birthday",
  "DeviceSummary.target_step.input": "Please enter target steps",
  "DeviceSummary.target_calorie.input": "Please enter target calories",
  "DeviceSummary.resetdevice": "Factory Reset",
  "DeviceSummary.resetdevice.notice":
    "Wearer information will be deleted, device will be restored to factory mode, are you sure?",
  "DeviceSummary.binded": "Bound",
  "DeviceSummary.day": "Days",
  "DeviceSummary.wear": "Wear",
  "IwownAi.aislogan": "I am a Microsoft chatbot, you can ask me questions",
  "IwownAi.aifailed": "Oops, beyond my understanding...",
  "IwownAi.hint": "Please enter your question...",
  "IwownAi.send": "Send",
  "HealthHome.pagetitle": "Data Overview",
  "HealthHome.hr": "Heart Rate",
  "HealthHome.rri": "Atrial Fibrillation",
  "HealthHome.step": "Steps",
  "HealthHome.sleep": "Sleep",
  "HealthHome.ecg": "ECG",
  "HealthHome.position": "Location",
  "HealthHome.hours": "Hours",
  "HealthHome.minutes": "Minutes",
  "HeartRate.abnormal": "Abnormal Heart Rate",
  "HeartRate.avghr": "Avg HR",
  "HeartRate.maxhr": "Max HR",
  "HeartRate.minhr": "Min HR",
  "HeartRate.avgsporthr": "Average Sport Heart Rate",
  "HeartRate.sporthr": "Sport Heart Rate",
  "HeartRate.minutes": "Minutes",
  "HeartRate.range_normal": "Normal",
  "HeartRate.range_warmup": "Warm-up",
  "HeartRate.range_burnfat": "Fat-burning",
  "HeartRate.range_aerobic": "Aerobic",
  "HeartRate.range_anaerobic": "Anaerobic",
  "HeartRate.range_extreme": "Extreme",
  "AtrialData.afdata": "Heart Health",
  "AtrialData.today24hours": "Today 24 Hours",
  "AtrialData.dateselect": "Select Date",
  "AtrialData.diagnosis": "Diagnosis Conclusion",
  "AtrialData.disclaimer":
    "Note: Non-medical diagnosis, for reference only. Please rely on hospital-confirmed conclusions.",
  "AtrialData.chart_title": "Scatter Plot",
  "AtrialData.nodata": "No atrial fibrillation data",
  "AtrialData.normal": "No atrial fibrillation detected temporarily. ",
  "AtrialData.abnormal": "Suspected atrial fibrillation. ",
  "AtrialData.noresult": "No result, interference or data anomaly. ",
  "AtrialData.SINUS_HR": "Sinus rhythm. ",
  "AtrialData.SINUS_BRADYCARDIA": "Sinus bradycardia. ",
  "AtrialData.SINUS_TACHYCARDIA": "Sinus tachycardia. ",
  "AtrialData.SINUS_ARRHYTHMIA": "Sinus arrhythmia (premature beat). ",
  "AtrialData.SINUS_ATRIAL_FIBRILLATION":
    "Sinus arrhythmia (atrial fibrillation). ",
  "AtrialData.SINUS_SUPRAVENTRICULAR_TACHYCARDIA":
    "Tachycardia (supraventricular tachycardia). ",
  "AtrialData.timebar_title":
    "Atrial Fibrillation Minutes/Hours in the Last 24 Hours",
  "AtrialData.hrbar_title": "Heart Rate Curve in the Last 24 Hours",
  "AtrialData.afchart_title":
    "Suspected Atrial Fibrillation Duration/Valid Measurement Duration Today in the Last 7 Days",
  "AtrialData.measure_time": "Measurement Time",
  "AtrialData.aftime": "Atrial Fibrillation Time",
  "AtrialData.time": "Time",
  "AtrialData.scatter.desc":
    "Scatter Plot: Based on non-linear chaotic theory, using fast computer computation technology to graphically represent long-term RR interval data for heart rate variability.",
  "EcgView.title": "ECG",
  "EcgView.ecgdatalist": "ECG Data List",
  "EcgView.normal": "Normal",
  "EcgView.SINUS.HR": "Sinus Rhythm",
  "EcgView.SINUS.BRADYCARDIA": "Suspected Sinus Bradycardia",
  "EcgView.SINUS.TACHYCARDIA": "Suspected Sinus Tachycardia",
  "EcgView.SINUS.ARRHYTHMIA": "Suspected Sinus Arrhythmia (Premature Beat)",
  "EcgView.SINUS.ATRIAL.FIBRILLATION":
    "Suspected Sinus Arrhythmia (Atrial Fibrillation)",
  "EcgView.SINUS.NOResult": "AI unable to analyze the result",
  "EcgView.loading": "Loading data...",
  "EcgView.note": "User Note",
  "EcgView.diagnosis": "Diagnosis Conclusion",
  "EcgView.disclaimer":
    "Note: The above diagnoses are given by the artificial intelligence diagnostic algorithm Cardiolearn, for reference only. Please rely on hospital-confirmed conclusions.",
  "EcgView.today": "Today",
  "EcgView.sevenday": "Last 7 Days",
  "EcgView.onemonth": "Last 30 Days",
  "EcgView.ecgtime": "Measurement Time",
  "EcgView.ai_result": "Analysis Result",
  "Sports.title": "Sports",
  "Sports.step": "Steps",
  "Sports.meter": "Meters",
  "Sports.minute": "Minutes",
  "Sports.unit": "Unit",
  "Sports.datalist": "Sports Data List",
  "Sports.step.title": "Step Count",
  "Sports.distance.title": "Distance Covered",
  "Sports.duration.title": "Duration of Exercise",
  "Sports.startime.title": "Start Time",
  "Sports.sportype.title": "Type of Exercise",
  "Sleep.title": "Sleep",
  "Sleep.hour": "Hours",
  "Sleep.minute": "Minutes",
  "Sleep.score": "Score",
  "Sleep.bless": "Please maintain good sleep habits!",
  "Sleep.light": "Light Sleep",
  "Sleep.deep": "Deep Sleep",
  "Sleep.awake": "Awake",
  "Sleep.rem": "REM (Rapid Eye Movement)",
  "Sleep.benchmark": "Reference Range: 10%-40%",
  "Sleep.score.prefix": "Your sleep score is",
  "Sleep.value.high": "High",
  "Sleep.value.low": "Low",
  "Sleep.value.normal": "Normal",
  "Sleep.light_desc":
    "Light sleep, also known as the mild sleep stage, accounts for approximately 65% of the entire sleep time. During this stage, the sleeper is less easily awakened, muscles further relax, and the EEG shows spindle sleep waves.",
  "Sleep.deep_desc":
    "Deep sleep, also known as the 'golden sleep,' accounts for about 25% of the entire sleep time. The cells of the cerebral cortex are in a fully rested state, helping to eliminate fatigue, restore energy, and enhance immunity.",
  "Sleep.awake_desc":
    "A reasonable sleep duration is 7-9 hours per night, ensuring the quality of sleep. Maintaining good sleep habits and following the natural rhythm of sleep are the best ways to reduce sleep awakenings.",
  "Sleep.rem_desc":
    "REM (Rapid Eye Movement) sleep, also known as rapid eye movement sleep, is a stage in the normal sleep cycle. During this stage, the eyes move rapidly in various directions, and the muscles of the body relax, presenting a temporary state of paralysis.",
  "Auth.Login.failed.title": "Login Failed",
  "Auth.Login.failed.desc": "Please check your account and password",
  "Auth.site.desc":
    "Watch Center is the data display platform for Microsoft 4G watches.",
  "Auth.username": "Username",
  "Auth.username.prompt": "Please enter your username!",
  "Auth.password": "Password",
  "Auth.password.prompt": "Please enter your password!",
  "Auth.autologin": "Auto Login",
  "Auth.login": "Login",
  "Auth.login.method.account": "Account Password Login",
  "OverView.listview.title": "Device ID",
  "Menu.dashboard": "Dashboard",
  "Menu.Monitor": "Monitoring Page",
  "Menu.Robot": "Robot",
  "Menu.Device": "Device",
  "Menu.DeviceList": "Device List",
  "DeviceSetting.Setting": "Device Settings",
  "DeviceSetting.Notification.Title": "Good News",
  "common.save.succeed": "Information saved successfully",
  "common.save.failed": "Failed to save information",
  "Export.button.name": "Export",
  "Export.Base.title": "Basic information",
  "Export.Base.nickname": "User nickname",
  "Export.Base.deviceId": "Device ID",
  "Export.Base.date": "Date",
  "Export.Base.details": "Detailed data",
  "Export.Base.times": "Time",
  "Export.Sleep.title": "Sleep Summary",
  "Export.Sleep.total": "Total sleep duration",
  "Export.Sleep.start": "Sleep time",
  "Export.Sleep.end": "Wake up time",
  "Export.Sleep.deep": "Deep sleep duration",
  "Export.Sleep.light": "Light sleep duration",
  "Export.Sleep.rem": "REM duration",
  "Export.Sleep.wake": "Awakening duration",
  "Export.Sleep.cycle": "Cycle",
  "Export.Sleep.duration": "Duration",
  "Export.Heart.hr": "Heart rate",
  "Export.Step.step": "Number of steps",
};
